import Swiper from 'swiper/bundle';
import {
  sliderBeforeInit,
  sliderInit,
  sliderDestroy,
  sliderOnChange,
} from '@helpers/slider-utils.js';

const { feWp } = window;
const { applyFilters, addAction, doAction } = feWp.hooks;

if (!window.Swiper) {
  window.Swiper = Swiper;
}
// Define a filter to override SwiperExt
applyFilters('b3rg_slider_library', Swiper);

const sliderDOMContentLoaded = (device) => {
  // Select all elements with the attribute 'data-swiper' except for specific classes
  const excludeSliders = applyFilters('b3rg_slider_exclude', []);
  const excludeSliderclass = Array.from(excludeSliders)
    .map((sliderClass) => {
      return `:not(.${sliderClass})`;
    })
    .join('');
  const sliderSelector = `.e-sld${excludeSliderclass} [data-swiper]`;

  const swiperSliders = document.querySelectorAll(sliderSelector);

  swiperSliders.forEach((el) => {
    const sliderOptions = JSON.parse(el.getAttribute('data-swiper')) || {};
    let sliderInstance = el.swiper;

    const swiperSettingsForTheBreakpoint = sliderOptions[device];

    if (!swiperSettingsForTheBreakpoint) return;

    const enableSlider = (settings) => {
      const defaultSliderSettings = {
        ...settings,
        on: {
          beforeInit() {
            doAction('b3rg_slider_before_init', settings, el);
            sliderBeforeInit(el);
          },
          init(swiper) {
            doAction('b3rg_slider_init', settings, el, swiper);
            sliderInit(el, swiper);
          },
          destroy() {
            doAction('b3rg_slider_destroy', settings, el);
            sliderDestroy(el);
          },
          slideChange(swiper) {
            doAction('b3rg_slider_slideChange', settings, el, swiper);
            sliderOnChange(el, swiper);
          },
        },
      };
      const sliderSettings = applyFilters(
        'b3rg_slider_extend',
        defaultSliderSettings,
        el,
      );
      const SwiperLibrary = applyFilters('b3rg_slider_library', Swiper);
      sliderInstance = new SwiperLibrary(el, sliderSettings);
    };

    // destroy/init the slider considering the breakpoint destroy settings
    if (swiperSettingsForTheBreakpoint?.destroy) {
      if (sliderInstance !== undefined) sliderInstance.destroy();
      el.classList.add('swiper-destroyed');
    } else {
      enableSlider(swiperSettingsForTheBreakpoint);
    }
  });
};

addAction(
  'b3rg_breakpoint_changed',
  'b3rg/slider',
  sliderDOMContentLoaded,
  10,
  1,
);

document.addEventListener('DOMContentLoaded', sliderDOMContentLoaded);
